import { SxProps, Theme } from "@mui/material";

export const popoverPaperStyles: SxProps<Theme> = (theme) => ({
  "--Paper-overlay": "none !important",
  "&::before": {
    background: "none !important",
  },
  backgroundColor: theme.palette.panelInfo.panel.bg,
  marginTop: { xs: "16px", sm: "75px" },
  width: "100%",
  maxWidth: {
    xs: "min(420px, 95vw)",
    sm: "min(520px, 95vw)",
    md: "min(520px, 95vw)",
    lg: "50vh",
  },
  borderRadius: 2,
  height: { xs: "calc(100dvh - 32px)", sm: "75dvh" },
  maxHeight: "calc(100dvh - 24px)",
  display: "flex",
  flexDirection: "column",
  "@media (max-height: 520px) and (orientation: landscape)": {
    marginTop: "8px",
    width: "min(94vw, 680px)",
    maxWidth: "94vw",
    height: "calc(100dvh - 16px)",
    maxHeight: "calc(100dvh - 16px)",
    borderRadius: "12px",
  },
});

export const headerBoxStyles: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: { xs: "16px", sm: "20px" },
  paddingX: { xs: "16px", sm: "24px" },
  "@media (max-height: 520px) and (orientation: landscape)": {
    paddingTop: "8px",
    paddingX: "12px",
  },
};

export const tabsStyles: SxProps<Theme> = (theme) => ({
  mt: 1,
  paddingX: { xs: "6px", sm: "4px" },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    gap: "10px",
    scrollbarWidth: "thin",
    scrollbarColor: `#c2c2c2 ${theme.palette.panelInfo.panel.bg}`,
    msOverflowStyle: "none",

    "&::-webkit-scrollbar": {
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#c2c2c2",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: theme.palette.panelInfo.panel.bg,
      borderRadius: "4px",
    },
  },
  "& .MuiTab-root": {
    borderRadius: "999px",
    py: "12px",
    px: "24px",
    minHeight: "auto",
    minWidth: "auto",
    textTransform: "none",
    backgroundColor: theme.palette.panelInfo.tab.bg,
    color: theme.palette.panelInfo.tab.color,
    fontWeight: 500,
    fontSize: "0.95rem",
    "@media (max-height: 520px) and (orientation: landscape)": {
      py: "8px",
      px: "14px",
      fontSize: "0.85rem",
    },
  },
  "& .MuiTab-root.Mui-selected": {
    backgroundColor: "#06B6D4",
    color: "#fff",
  },
});

export const contentBoxStyles: SxProps<Theme> = (theme) => ({
  p: 2,
  flex: 1,
  overflowY: "scroll",
  paddingX: { xs: "16px", sm: "24px" },
  "@media (max-height: 520px) and (orientation: landscape)": {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingX: "12px",
  },

  scrollbarWidth: "thin",
  scrollbarColor: `#c2c2c2 ${theme.palette.panelInfo.panel.bg}`,

  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#c2c2c2",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-track": {
    background: theme.palette.panelInfo.panel.bg,
    borderRadius: "4px",
  },

  scrollbarGutter: "stable",
});
